export default {"src":"/_next/static/media/logo.465d5449.svg","height":128,"width":128};